import StrengthCard from '@components/pages/cpa/epnbz/BlockOurStrength/StrengthCard';
import ContainerWithLayout from '@components/pages/home/epnbz/Base/ContainerWithLayout';
import SectionTitle from '@components/pages/home/epnbz/Base/SectionTitle';
import useI18n from '@i18n';

import styles from './OurStrength.module.scss';

import IntegrationImg from './img/integration.svg';
import SinceImg from './img/since.svg';
import SupportImg from './img/support.svg';
import TrafficImg from './img/traffic.svg';
import WebmastersImg from './img/webmaster.svg';

const BlockOurStrength: React.FC = () => {
    const { t } = useI18n('Cpa');

    return (
        <section className={styles.blockOurStrength}>
            <ContainerWithLayout colorName="red">
                <div className={styles.landingContainer}>
                    <div className={styles.wrapper}>
                        <div className={styles.row}>
                            <SectionTitle classname={styles.title} bigger>
                                {t('What is our strength?')}
                            </SectionTitle>
                            <StrengthCard
                                title={t('Quality traffic')}
                                text={t(
                                    'We are interested in profitable cooperation and monitor the quality of our partners traffic',
                                )}
                                imgSrc={TrafficImg}
                            />
                            <StrengthCard
                                title={t('Working since 2013')}
                                text={t(
                                    'We have been in the market for a long time, and during this time, we have established ourselves as a large and reliable partner.',
                                )}
                                imgSrc={SinceImg}
                            />
                            <StrengthCard
                                title={t('Fast and easy integration')}
                                text={t(
                                    'We carry out integration in the shortest possible time, taking into account all nuances and helping to set up everything so that it works perfectly.',
                                )}
                                imgSrc={IntegrationImg}
                            />
                            <StrengthCard
                                title={t('Personalized support')}
                                text={t(
                                    'A personal manager is available to support you at all stages, from launching your offer to making the first sales.',
                                )}
                                imgSrc={SupportImg}
                            />
                            <StrengthCard
                                title={t('Database of 700,000 Webmasters')}
                                text={t(
                                    'We will find a webmaster for any affiliate program and the required traffic.',
                                )}
                                imgSrc={WebmastersImg}
                                isLast
                            />
                        </div>
                    </div>
                </div>
            </ContainerWithLayout>
        </section>
    );
};

export default BlockOurStrength;
